import React, { useContext } from "react";
import ConfiguratorContext from "../components/ConfiguratorContext";

const ConnectionCustomInput = ({
  value,
  label,
  symbol,
  unitOfMeasurement,
  onChange,
}) => {
  return (
    <div className="flex space-x-4">
      {!!label && <div className="flex items-center w-1/3">{label}</div>}
      <div className="flex w-96 my-2">
        <div className="flex justify-center items-center w-3/12 h-10 bg-gray-100 border">
          {symbol}
        </div>
        <input
          type="number"
          value={value || ""}
          className="p-4 h-10 border-gray-200 border border-l-0 border-r-0 w-5/12"
          onChange={onChange}
        />
        <div className="flex justify-center items-center w-3/12 h-10 bg-gray-100 border">
          {unitOfMeasurement}
        </div>
      </div>
    </div>
  );
};
export default ConnectionCustomInput;
